var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-right mb-0 text-white"},[_vm._v(_vm._s(_vm.timeRemaining))])}
var staticRenderFns = []

export { render, staticRenderFns }